import React from 'react';
import { Helmet } from 'react-helmet';
import appBranding from '@happylife-a/branding';

const getField = appBranding.configs.environments.getField;
const fieldsAppBranding = appBranding.fields.brand.AppBranding;

export default function GlobalCssVariables() {
  const themeColor = getField(fieldsAppBranding.ThemeColor);

  return (
    <Helmet>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: `
          :root {
            --branding-color: ${themeColor};
          }
        `,
        }}
      />
    </Helmet>
  );
}
